if (!customElements.get('size-guide-modal')) {
  class SizeGuideModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-size-guide-dialog]');
      if (!this.dialog) return;

      this.closeBtn = this.querySelector('[data-size-guide-close]');
      const scope = this.closest('.shopify-section') ?? document;
      this.triggers = scope.querySelectorAll('[data-size-guide-open]');

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);

      for (const trigger of this.triggers) trigger.addEventListener('click', this.open);
      this.closeBtn?.addEventListener('click', this.close);

      // Close when the backdrop (the dialog element itself) is clicked; clicks on the panel bubble from children.
      this.dialog.addEventListener('click', this.onDialogClick);

      // Native 'close' fires for every close path (button, backdrop, Escape) — unlock scroll here.
      this.dialog.addEventListener('close', this.onDialogClose);
    }

    disconnectedCallback() {
      if (this.triggers) {
        for (const trigger of this.triggers) trigger.removeEventListener('click', this.open);
      }
      this.closeBtn?.removeEventListener('click', this.close);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('close', this.onDialogClose);
    }

    onDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    onDialogClose() {
      document.body.classList.remove('size-guide-open');
    }

    open() {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
      document.body.classList.add('size-guide-open');
    }

    close() {
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        document.body.classList.remove('size-guide-open');
      }
    }
  }

  customElements.define('size-guide-modal', SizeGuideModal);
}
